import React from 'react';
import Link from 'next/link';

const TitleSection = ({ title, btnTxt, bg, href, hrefExt }) => {
  return (
    <>
      {bg == 'black' ? (
        <div>
          <div className="w-full" style={{ backgroundColor: '#171717' }}>
            <div className="lg:container text-center lg:text-start pt-4 pb-4  ">
              <div className="flex pt-4 pb-3 justify-center gap-x-4 items-center ">
                <div className="">
                  <div>
                    <h3
                      className="text-uppercase text-white  text-[48px] leading-[54px] font-normal lg:text-end text-center"
                      style={{ fontFamily: 'josefin sans',  }}>
                      {title}
                    </h3>
                  </div>
                </div>
                <div className=" mt-3 md:mt-0">
                  <div>
                    {href ? (
                      <Link href={href}>
                        <button
                          type="button"
                          className="btn rounded-0 "
                          style={{
                            fontFamily: 'Josefin Sans',
                            color: '#010101',
                            backgroundColor: '#FCBD00',

                            padding: '13px 30px',
                          }}>
                          {btnTxt}
                        </button>
                      </Link>
                    ) : (
                      <a href={hrefExt} target="_blank" rel="noreferrer">
                        <button
                          type="button"
                          className="btn text-[18px] leading-[27px] rounded-0 "
                          style={{
                            fontFamily: 'Josefin Sans',
                            color: '#010101',
                            backgroundColor: '#FCBD00',

                            padding: '13px 30px',
                          }}>
                          {btnTxt}
                        </button>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="w-full" style={{ backgroundColor: '#fffff' }}>
            <div className="lg:container mx-auto text-center pt-4 pb-4  ">
              <div className="flex mt-4 mb-4 pt-4 pb-3 justify-center items-center gap-x-4">
                <div className="">
                  <div>
                    <h3
                      className="text-uppercase text-dark  text-[48px] leading-[54px] font-normal lg:text-end text-center"
                      style={{ fontFamily: 'josefin sans', color: '#000000' }}>
                      {title}
                    </h3>
                  </div>
                </div>
                <div className=" mt-3 md:mt-0">
                  <div>
                    {href ? (
                      <Link href={href}>
                        <button
                          type="button"
                          className="btn rounded-0 "
                          style={{
                            fontFamily: 'Josefin Sans',
                            color: '#010101',
                            backgroundColor: '#FCBD00',

                            padding: '13px 30px',
                          }}>
                          {btnTxt}
                        </button>
                      </Link>
                    ) : (
                      <a href={hrefExt} target="_blank" rel="noreferrer">
                        <button
                          type="button"
                          className="btn  font-semibold text-[18px] leading-[27px] rounded-0 "
                          style={{
                            fontFamily: 'Josefin Sans',
                            color: '#010101',
                            backgroundColor: '#FCBD00',

                            padding: '13px 30px',
                          }}>
                          {btnTxt}
                        </button>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TitleSection;
